import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'desc',
        sortBy: 'releaseDate',
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  isChecked: false,
  stateprovinces: storage.session.getItem(types.STORE_STATEPROVINCES)
    ? JSON.parse(storage.session.getItem(types.STORE_STATEPROVINCES))
    : [],
  timezones: storage.session.getItem(types.STORE_TIMEZONES)
    ? JSON.parse(storage.session.getItem(types.STORE_TIMEZONES))
    : [],

  defaultApplication: {
    id: null,
    appKey: null,
    name: null,
    version: null,
    OS: null,
    isRequired: 1,
    message: null,
    releaseDate: null,
    title: null,
  },
  applications: [],
  application: null,
  defaultAssessment: {
    id: null,
    assessmentType: null,
    instructions: null,
    testType: null,
    url_1: null,
    url_2: null,
  },
  assessmentTypes: [],
  assessments: [],
  assessment: null,
  defaultSetting: {
    id: null,
    Name: null,
    Classification: null,
    TextValue: null,
    Value: null,
    IsInactive: 0,
    Sort: 0,
    orgid: 1,
  },
  settings: [],
  setting: null,
  assessmentNorms: [],
  defaultBiTemplate: {
    id: null,
    name: null,
    column: null,
    ranges: [],
    isChanged: true,
  },
  biTemplates: [],
  selectedBiTemplate: null,
})
